import { render, staticRenderFns } from "./handover_list.vue?vue&type=template&id=154d8412&scoped=true"
import script from "./handover_list.vue?vue&type=script&lang=js"
export * from "./handover_list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "154d8412",
  null
  
)

export default component.exports